export function updateDrawerBackgroundInteractivity({
  activeElement,
  drawer,
  hidden,
  targets,
}) {
  const elements = (targets || []).filter(Boolean);

  if (hidden) {
    const focusIsBeingHidden =
      activeElement &&
      elements.some((element) => element.contains?.(activeElement));

    if (focusIsBeingHidden) {
      drawer?.focus?.({ preventScroll: true });
    }

    elements.forEach((element) => element.setAttribute("inert", ""));
    return;
  }

  elements.forEach((element) => element.removeAttribute("inert"));
}
